<form *ngIf="formLink && fields" [formGroup]="formLink" [ngClass]="{'invalid-submit': invalidSubmit}" >

  <div class="card Loyalty">
    <div class="ui-g">
      <div class="ui-g-12">
        <h2>{{ 'common.storeLink' | translate }}</h2>
      </div>
    </div>
    <div class="ui-g ui-g-nopad form-group">

      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.analitics_id.nullable}">{{ fields.analitics_id.keyName }}</span>
        <p-dropdown [options]="listAnalyticType" [filter]="true" formControlName="analitics_id" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.analitics_id"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.backoffice_id.nullable}">{{ fields.backoffice_id.keyName }}</span>
        <p-dropdown [options]="listBackOfficeType" [filter]="true" formControlName="backoffice_id" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.backoffice_id"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.front_end_id.nullable}">{{ fields.front_end_id.keyName }}</span>
        <p-dropdown [options]="listFrontEndType" [filter]="true" formControlName="front_end_id" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.front_end_id"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.loyalty_id.nullable}">{{ fields.loyalty_id.keyName }}</span>
        <p-dropdown [options]="listLoyaltyType" [filter]="true" formControlName="loyalty_id" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.loyalty_id"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.promotion_id.nullable}">{{ fields.promotion_id.keyName }}</span>
        <p-dropdown [options]="listPromotionType" [filter]="true" formControlName="promotion_id" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.promotion_id"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.customer_id.nullable}">{{ fields.customer_id.keyName }}</span>
        <p-dropdown [options]="listCustomerType" [filter]="true" formControlName="customer_id" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.customer_id"></app-validation-msg>
      </div>
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.couponing_id.nullable}">{{ fields.couponing_id.keyName }}</span>
        <p-dropdown [options]="listCouponingType" [filter]="true" formControlName="couponing_id" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.couponing_id"></app-validation-msg>
      </div>
      <div class="ui-g-8 form-control">
        <span class="label" [ngClass]="{'required': !fields.ip_address.nullable}">{{ fields.ip_address.keyName }}</span>
        <input pInputText type="text" formControlName="ip_address" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.ip_address"></app-validation-msg>
      </div>
      <!-- Url Flyer -->
      <div class="ui-g-4 form-control">
        <span class="label" [ngClass]="{'required': !fields.ext_flyer_url.nullable}">{{ fields.ext_flyer_url.keyName }}</span>
        <input pInputText type="text" formControlName="ext_flyer_url"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.ext_flyer_url"></app-validation-msg>
      </div>
      <div class="ui-g-8 form-control"></div>
      <div class="ui-g-6 form-control">
        <span class="label" [ngClass]="{'required': !fields.flg_graphical_printer.nullable}">{{ fields.flg_graphical_printer.keyName }}</span>
        <p-inputSwitch formControlName="flg_graphical_printer"></p-inputSwitch>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.flg_graphical_printer"></app-validation-msg>
      </div>
      <div class="ui-g-6 form-control">
        <span class="label" [ngClass]="{'required': !fields.flg_campaign_candidate.nullable}">{{ fields.flg_campaign_candidate.keyName }}</span>
        <p-inputSwitch formControlName="flg_campaign_candidate"></p-inputSwitch>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="formLink" [validation]="fields.flg_campaign_candidate"></app-validation-msg>
      </div>

    </div>
  </div>



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-link/store-common-link.component.html